var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-cdm {\n  background: #d21111 url(" + escape(require("../../assets/caidengmi/bg.png")) + ");\n  background-size: 100% 100%;\n  overflow: hidden;\n  height: 100vh;\n}\n.page-cdm .btn-cdm {\n  position: fixed;\n  bottom: 25%;\n  left: 34%;\n  background: #ed442d;\n  border: 2px solid #ffcc32;\n  border-radius: 40px;\n  padding: 5px 30px;\n  color: #ffcc32;\n  display: inline-block;\n  font-size: 20px;\n  font-weight: bold;\n  -webkit-box-shadow: 0 3px 0 #771805;\n          box-shadow: 0 3px 0 #771805;\n}\n.page-cdm .rule {\n  position: fixed;\n  color: #ffd43e;\n  bottom: 20%;\n  left: 45%;\n  text-decoration: underline;\n}\n", ""]);

// exports
